import { Box } from '@mui/material';
import { EmailAuthProvider, GoogleAuthProvider } from 'firebase/auth';
import { auth } from 'firebaseui';
import { FC, useEffect } from 'react';
import { firebaseUI } from '../firebase';
// const { NotificationManager } = require('react-notifications');
// const firebase = require('firebase/compat/app').default;



interface LoginProps {
    onSuccess?: (authResult: any) => boolean;
}

type Props = LoginProps;


const Login: FC<Props> = (props: Props) => {
    const { onSuccess } = props;
    // const { firebaseui: firebaseuiHebrew } = useScript('firebaseui',
    //     `https://www.gstatic.com/firebasejs/ui/6.0.2/firebase-ui-auth__iw.js`
    // );
    // useEffect(() => {
    //     if (firebase) (window as any).firebase = firebase;
    // }, []);

    useEffect(() => {
        // if (firebaseuiHebrew) {
        // const ui = firebaseuiHebrew.auth.AuthUI.getInstance() ||
        //     new firebaseuiHebrew.auth.AuthUI(getAuth(firebaseApp));

        firebaseUI.start('#firebaseui-auth-container', {
            signInOptions: [
                {
                    provider: EmailAuthProvider.PROVIDER_ID,
                    requireDisplayName: false,
                    buttonColor: "#0f4687"
                },
                {
                    provider: GoogleAuthProvider.PROVIDER_ID,

                },

            ],
            signInSuccessUrl: "/user",
            signInFlow: "popup",
            callbacks: {
                signInSuccessWithAuthResult: (authResult, redirectResult) => {
                    if (onSuccess) {
                        return onSuccess(authResult);
                    }
                    return true;
                }
            }
        } as auth.Config);
        // }

    }, [onSuccess])
    return <Box id="firebaseui-auth-container" >
    </Box>;
}


export default Login;

